module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a6LaO"))).then(() => module.bundle.root('d0iPb'));